import {
  DocBody,
  DocHeader,
  LogoBox,
  DocTitle,
  TopMetaRow,
  CheckGroup,
  CheckItem,
  CheckSquare,
  SlashText,
  LockerRow,
  LockerUnderline,
  SectionHeader,
  SectionTitle,
  AgreeGroup,
  AgreeText,
  AgreeCheck,
  TableWrap,
  TableCol,
  HalfCol,
  FullCol,
  LabelCell,
  ValueCell,
  PeriodBox,
  PeriodRow,
  TermBody,
  SignDateRow,
  SignDateBlank,
  SignRow,
  SignItem,
  SignLabel,
  SignNameBlank,
  SignStampBox,
  ThanksText,
  ThanksStrong,
  ThanksNormal,
} from './ElectronicContractPreviewStyled';

// 개인정보 표 행 — 4컬럼 (라벨/값/라벨/값)
const PERSONAL_ROWS = [
  { leftLabel: '성명', rightLabel: '성별' },
  { leftLabel: '연락처', rightLabel: '생년월일' },
  { leftLabel: '주소', rightLabel: '담당자' },
];

// 요금 상세 행 (label, 단위)
const FEE_ROWS = [
  { label: '회원권', unit: '원' },
  { label: '일반상품', unit: '원' },
  { label: '라커', unit: '원' },
  { label: '할인금액', unit: '원' },
  { label: '미수금', unit: '원', danger: true },
];

// 이용기간 셀의 높이 = 요금 행 수 + 합계 행
const PERIOD_CELL_HEIGHT = (FEE_ROWS.length + 1) * 32;

// 회원권 계약서 미리보기 (Figma 5183:7852 / 5183:8208)
const ElectronicContractPreviewPageMembership = ({ name, branchName, logoUrl, sealUrl, termSections = [] }) => (
  <DocBody>
    {/* 로고 + 제목 */}
    <DocHeader>
      <LogoBox>{logoUrl && <img src={logoUrl} alt="로고" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}</LogoBox>
      <DocTitle>{name || '바디스위치 피트니스 이용권 계약서'}</DocTitle>
      <div style={{ width: 120, flexShrink: 0 }} />
    </DocHeader>

    {/* 신규/재등록 + 라커번호 */}
    <TopMetaRow>
      <CheckGroup>
        <CheckItem>
          <CheckSquare />
          신규
        </CheckItem>
        <SlashText>/</SlashText>
        <CheckItem>
          <CheckSquare />
          재등록
        </CheckItem>
      </CheckGroup>
      <LockerRow>
        라커번호 :<LockerUnderline />
      </LockerRow>
    </TopMetaRow>

    {/* 개인정보 — 4컬럼 테이블 */}
    <FullCol>
      <SectionHeader rounded="top">
        <SectionTitle>개인정보</SectionTitle>
      </SectionHeader>
      {PERSONAL_ROWS.map(row => (
        <TableWrap key={row.leftLabel}>
          <TableCol fixed={100}>
            <LabelCell>{row.leftLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell />
          </TableCol>
          <TableCol fixed={100}>
            <LabelCell>{row.rightLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell />
          </TableCol>
        </TableWrap>
      ))}
    </FullCol>

    {/* 시설이용 + 요금 상세 내용 */}
    <TableWrap>
      <HalfCol>
        <SectionHeader rounded="tl">
          <SectionTitle>시설이용</SectionTitle>
        </SectionHeader>
        <TableWrap>
          <TableCol fixed={100}>
            <LabelCell cellHeight={PERIOD_CELL_HEIGHT}>이용기간</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell cellHeight={PERIOD_CELL_HEIGHT}>
              <PeriodBox>
                <span>회원권명</span>
                <PeriodRow>
                  <span>년</span>
                  <span>월</span>
                  <span>일 부터</span>
                </PeriodRow>
                <PeriodRow>
                  <span>년</span>
                  <span>월</span>
                  <span>일 까지</span>
                </PeriodRow>
              </PeriodBox>
            </ValueCell>
          </TableCol>
        </TableWrap>
      </HalfCol>

      <HalfCol borderLeft>
        <SectionHeader rounded="tr">
          <SectionTitle>요금 상세 내용</SectionTitle>
        </SectionHeader>
        <TableWrap>
          <TableCol fixed={100}>
            {FEE_ROWS.map(row => (
              <LabelCell key={row.label} danger={row.danger}>
                {row.label}
              </LabelCell>
            ))}
            <LabelCell tone="sum">합계</LabelCell>
          </TableCol>
          <TableCol>
            {FEE_ROWS.map((row, idx) => (
              <ValueCell key={`${row.label}-${idx}`} align="flex-end">
                {row.unit}
              </ValueCell>
            ))}
            <ValueCell align="flex-end">원</ValueCell>
          </TableCol>
        </TableWrap>
      </HalfCol>
    </TableWrap>

    {/* 약관 섹션 — 선택된 조항만 표시 */}
    {termSections.map(term => (
      <FullCol key={term.title}>
        <SectionHeader rounded="top">
          <SectionTitle>{term.title}</SectionTitle>
          <AgreeGroup>
            <AgreeText>아래 약관을 확인하였으며 동의합니다.</AgreeText>
            <AgreeCheck />
          </AgreeGroup>
        </SectionHeader>
        <TermBody>{term.body}</TermBody>
      </FullCol>
    ))}

    {/* 서명 */}
    <SignDateRow>
      <SignDateBlank />
      <span>년</span>
      <SignDateBlank />
      <span>월</span>
      <SignDateBlank />
      <span>일</span>
    </SignDateRow>
    <SignRow>
      <SignItem>
        <SignLabel>담당자</SignLabel>
        <SignNameBlank />
        <SignStampBox filled>
          {sealUrl && <img src={sealUrl} alt="직인" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}
        </SignStampBox>
      </SignItem>
      <SignItem>
        <SignLabel>계약자</SignLabel>
        <SignNameBlank />
        <SignStampBox />
      </SignItem>
    </SignRow>

    {/* 감사 문구 */}
    <ThanksText>
      <ThanksStrong>{branchName || '지점'}</ThanksStrong>
      <ThanksNormal>의 회원이 되어주셔서 감사드립니다.</ThanksNormal>
    </ThanksText>
  </DocBody>
);

export default ElectronicContractPreviewPageMembership;
